import { render } from "./ToolbarLink.vue?vue&type=template&id=2fbdc3ec&scoped=true"
import script from "./ToolbarLink.vue?vue&type=script&lang=js"
export * from "./ToolbarLink.vue?vue&type=script&lang=js"

import "./ToolbarLink.vue?vue&type=style&index=0&id=2fbdc3ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbdc3ec"]])

export default __exports__